<div class="rightview" [ngClass]="{'!top-[61px]': top === 'header'}">
    <div class="bodyview">
        <ng-content></ng-content>
    </div>
</div>